import { Dialog } from '@progress/kendo-react-dialogs'
import DropDownKendoRct from 'src/control-components/drop-down/drop-down'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clinicService } from 'src/services/clinicService'
import { GET_CUSTOMER_STATUSES } from 'src/actions'
import NOTIFICATION_MESSAGE from 'src/helper/notification-messages'
import { NotificationManager } from 'src/util/notify'
import { getCustomerStatusConfig } from 'src/helper/customer-status-config'

const UpdateCustomerStatus = ({ onClose, onClear, clinicIds, getAllClinic, currentCustomerStatus}) => {
  const dispatch = useDispatch()
  const customerStatuses = useSelector((state: any) => state.customerStatuses)
  const [selectedStatus, setSelectedStatus] = useState<any>(currentCustomerStatus || null)
  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (!customerStatuses || customerStatuses.length === 0) {
      clinicService.getCustomerStatuses()
        .then((result) => {
          dispatch({
            type: GET_CUSTOMER_STATUSES,
            payload: result.resultData,
          })
        })
        .catch((error) => {
          NOTIFICATION_MESSAGE.error(error)
        })
    }
  }, [])

  const updateCustomerStatuses = async () => {
    if (!clinicIds || clinicIds.length === 0) {
      NotificationManager.error("Please select at least one clinic.");
      return;
    }
    if (!selectedStatus) {
      NotificationManager.error("Please select customer status.");
      return;
    }
    await clinicService.updateCustomerStatuses(clinicIds, selectedStatus!.id)
      .then(() => {
        NotificationManager.success("Customer status updated successfully.");
        onClear();
        getAllClinic();
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };


  const handleUpdate = () => {
    let formIsValid = true;
    let errors: Record<string, string> = {};

    if (!selectedStatus) {
      formIsValid = false;
      errors["customerStatus"] = "Customer Status is required";
    }

    setErrors(errors);

    if (formIsValid) {
      updateCustomerStatuses();
    }
  };
  const handleStatusChange = (e: any) => {
    setSelectedStatus(e.target.value);

    setErrors((prev) => ({
      ...prev,
      customerStatus: "",
    }));
  };
  const renderStatusItem = (
    li: React.ReactElement<HTMLLIElement>,
    itemProps: any
  ) => {
    const dataItem = itemProps.dataItem;
  
    const config = getCustomerStatusConfig(
      dataItem?.statusName
    );
  
    const isSelected = li.props.className?.includes(
      "k-selected"
    );
  
    const itemChildren = (
      <div className="d-flex align-items-center justify-content-between w-100 px-1 py-1">
  
        <span
          style={{
            fontSize: "13px",
            fontWeight: 500,
            color: isSelected ? "#fff" : "#1E293B",
          }}
        >
          {dataItem?.statusName}
        </span>
  
        <div
          className="d-flex align-items-center justify-content-center rounded-circle"
          style={{
            width: "24px",
            height: "24px",
            background: isSelected
              ? "rgba(255,255,255,0.18)"
              : config.bg,
            color: isSelected
              ? "#fff"
              : config.color,
            border: isSelected
              ? "1px solid rgba(255,255,255,0.25)"
              : `1px solid ${config.border}`,
            flexShrink: 0,
            transition: "0.2s ease",
          }}
        >
          <i
            className={config.icon}
            style={{
              fontSize: "10px",
              color: isSelected
                ? "#fff"
                : config.color,
            }}
          />
        </div>
      </div>
    );
  
    return React.cloneElement(
      li,
      li.props,
      itemChildren
    );
  };
  return (
    <Dialog
      onClose={onClose}
      title={"Update Customer Status"}
      className="small-dailog scrollbar-width-none"
      width={"40%"}
      // height={"30%"}
    >
      <div className='col-12 edit-client-popup' style={{height:"stretch"}}>
        <DropDownKendoRct
          label="Customer Status"
          onChange={handleStatusChange}
          data={customerStatuses || []}
          value={selectedStatus}
          validityStyles={false}
          required={true}
          defaultValue={null}
          disabled={false}
          textField="statusName"
          name="customerStatus"
          dataItemKey="id"
          suggest={true}
          error={errors.customerStatus}
          itemRender={renderStatusItem}
        />
      </div>
      <div className="preview-btn-bottom pt-0 ">
        <div className="border-bottom-line mt-0 mb-2"></div>
        <div className="d-flex pl-2" >
          <button onClick={handleUpdate}
            className="btn blue-primary text-white green-btn btn-space btn-primary"
          >
            Update
          </button>
          <button
            className="btn grey-secondary text-white btn-space mx-2"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  )
}

export default UpdateCustomerStatus